import { useState, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function Xml() {
  const { pathname } = useLocation();
  const [activeTab, setActiveTab] = useState(1);
  const copyBodyRef = useRef(null);
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    const text = copyBodyRef.current.innerText;
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); 
    });
  };
  return (
    <>
      <div className="doc-content">
        <h3 className="text-left pb-24 doc-title">Create Order Purchase</h3>
        <h4 className="pb-16 sub-title flex-items-center">
          <span className="xml-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21.477"
              height="25.5"
              viewBox="0 0 21.477 25.5"
            >
              <g
                id="Type_Code_-_XML_Style_Default"
                data-name="Type= Code - XML, Style=Default"
                transform="translate(-1)"
              >
                <path
                  id="Path_6092"
                  data-name="Path 6092"
                  d="M23.516,5.448V22.724A2.026,2.026,0,0,1,21.49,24.75H7.776A2.026,2.026,0,0,1,5.75,22.724V2.776A2.026,2.026,0,0,1,7.776.75H18.4Z"
                  transform="translate(-1.789)"
                  fill="none"
                  stroke="#d0d5dd"
                  stroke-width="1.5"
                />
                <path
                  id="Path_6093"
                  data-name="Path 6093"
                  d="M24.623,1h0Zm5.3,5.922H25.247A1.247,1.247,0,0,1,24,5.675h5.922Zm-4.675,0A1.247,1.247,0,0,1,24,5.675V1h1.247V6.922ZM29.922,1V1Z"
                  transform="translate(-8.662 -0.094)"
                  fill="#d0d5dd"
                />
                <rect
                  id="Rectangle_2270"
                  data-name="Rectangle 2270"
                  width="16.208"
                  height="8.104"
                  rx="2"
                  transform="translate(1 12.75)"
                  fill="#2d3282"
                />
                <path
                  id="Path_6094"
                  data-name="Path 6094"
                  d="M6.611,27.356l-.891-1.34-.785,1.34H3.724l1.4-2.225L3.693,22.98H4.934L5.813,24.3l.773-1.322H7.795L6.4,25.187l1.446,2.169Zm6.732-4.376v4.376H12.276V24.732L11.3,27.356h-.86l-.985-2.631v2.631H8.386V22.98H9.645l1.228,3.03,1.216-3.03Zm1.833,3.553h1.4v.823H14.109V22.98h1.066Z"
                  transform="translate(-1.014 -8.372)"
                  fill="#fff"
                />
              </g>
            </svg>
          </span>
          <span className="pl-12"> XML</span>
        </h4>
        <div className="sub-link  pb-32">
          <p className="black">Example of the request url:</p>
          <a
            href="https://libertypaytextes.lb.ge:6444/order?terminalid=41"
            target="_blank"
            className="link fnt-14 underline "
          >
            https://libertypaytextes.lb.ge:6444/order?terminalid=41
          </a>
        </div>

        <div className="tabs-content">
          <div className="flex-items-center tabs-header">
            {/* tabs content */}
            <div className="tabs-button">
              <div
                className={activeTab === 1 ? "active-tab" : "tab"}
                onClick={() => setActiveTab(1)}
              >
                Request
              </div>
              <div
                className={activeTab === 2 ? "active-tab" : "tab"}
                onClick={() => setActiveTab(2)}
              >
                Response
              </div>
            </div>
            <button className={`btn btn-copy ${copied ?'copied':''}`} onClick={handleCopy}>
              <svg
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <title>Organization / File / copy--file</title>
                  <g
                    id="Organization-/-File-/-copy--file"
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <rect
                      fill="#FFFFFF"
                      opacity="0"
                      x="0"
                      y="0"
                      width="24"
                      height="24"
                    ></rect>
                    <path
                      d="M20.55,11.025 L15.975,6.45 C15.75,6.15 15.375,6 15,6 L9,6 C8.175,6 7.5,6.675 7.5,7.5 L7.5,21 C7.5,21.825 8.175,22.5 9,22.5 L19.5,22.5 C20.325,22.5 21,21.825 21,21 L21,12.075 C21,11.7 20.85,11.325 20.55,11.025 Z M15,7.5 L19.425,12 L15,12 L15,7.5 Z M9,21 L9,7.5 L13.5,7.5 L13.5,12 C13.5,12.825 14.175,13.5 15,13.5 L19.5,13.5 L19.5,21 L9,21 Z M4.5,13.5 L3,13.5 L3,3 C3,2.175 3.675,1.5 4.5,1.5 L15,1.5 L15,3 L4.5,3 L4.5,13.5 Z"
                      id="Fill"
                      fill="#fff"
                    ></path>
                  </g>
                </svg>
                
             <span>  {copied ? "Copied" : "Copy"}  </span>
            </button>
          </div>

          <div className="tab-content">
            {activeTab === 1 ? (
              <>
                <div className="code-ceontent">
                  <div className="code-body">
                    <pre ref={copyBodyRef} style={{ whiteSpace: "pre-wrap" }}>
                      <code>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="punctuation">{"<"}</span>
                          <span className="token token-line-head">?xml version="1.0" encoding="UTF-8"?</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>

                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property">TKKPG</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">    </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Request</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Operation</span>
                          <span className="punctuation">{">"}</span>
                          <span>CreateOrder</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Operation</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Language</span>
                          <span className="punctuation">{">"}</span>
                          <span>RU</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Language</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Order</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">OrderType</span>
                          <span className="punctuation">{">"}</span>
                          <span>Purchase</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">OrderType</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Merchant</span>
                          <span className="punctuation">{">"}</span>
                          <span>IA00007A</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Merchant</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Amount</span>
                          <span className="punctuation">{">"}</span>
                          <span>1</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Amount</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Currency</span>
                          <span className="punctuation">{">"}</span>
                          <span>981</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Currency</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Description</span>
                          <span className="punctuation">{">"}</span>
                          <span>xxxxxxxx</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Description</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">ApproveURL</span>
                          <span className="punctuation">{">"}</span>
                          <span>https://libertypaytxtest.lb.ge/</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">ApproveURL</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">CancelURL</span>
                          <span className="punctuation">{">"}</span>
                          <span>https://libertypaytxtest.lb.ge/</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">CancelURL</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">DeclineURL</span>
                          <span className="punctuation">{">"}</span>
                          <span>https://libertypaytxtest.lb.ge/</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">DeclineURL</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">AddParams</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">AddParams</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Order</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">    </span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Request</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">TKKPG</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                      </code> 
                    </pre>
                  </div>
                </div>
                <div className="where-operation">
                  <h3>Where:</h3>
                  <div className="operation-text">
                    <p>
                      <span className="tag">Operation</span>
                      <span>- Operation Type.</span>
                    </p>
                    <p>
                      <span className="tag">Language</span>
                      <span>- Interface language Language.</span>
                    </p>
                    <p>
                      <span className="tag">OrderType</span>
                      <span>
                        - Order Type. The financial transaction to be created.
                        Specify the Purchase value toperform the purchase.
                      </span>
                    </p>
                    <p>
                      <span className="tag">Merchant</span>
                      <span>- Internet shop ID.</span>
                    </p>
                    <p>
                      <span className="tag">Amount</span>
                      <span>
                        - Transaction amount in the minimum units of the
                        transaction currency.
                      </span>
                    </p>
                    <p>
                      <span className="tag">Currency</span>
                      <span>
                        - Transaction currency code (e.g. 981– Georgian Lari,
                        840 – US Dollar)
                      </span>
                    </p>
                    <p>
                      <span className="tag">Description</span>
                      <span>
                        - Order text description. It is displayed to the
                        customer during payment.
                      </span>
                    </p>
                    <p>
                      <span className="tag">ApproveURL</span>
                      <span>
                        - URL to forward the customer to if the operation is
                        approved. If the parameter is not defined, its value will
                        be taken from the parameter of the same name specified
                        in the merchant settings.
                      </span>
                    </p>
                    <p>
                      <span className="tag">CancelURL</span>
                      <span>
                        - URL to forward the customer to if the operation is
                        cancelled (by clicking the Cancel button).
                      </span>
                    </p>
                    <p>
                      <span className="tag">DeclineURL</span>
                      <span>
                        - URL to forward the customer to if the payment
                        operationis declined.
                      </span>
                    </p>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="code-ceontent">
                  <div className="code-body">
                      <pre ref={copyBodyRef} style={{ whiteSpace: "pre-wrap" }}>
                      <code>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property">TKKPG</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">    </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Response</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Operation</span>
                          <span className="punctuation">{">"}</span>
                          <span>CreateOrder</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Operation</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Status</span>
                          <span className="punctuation">{">"}</span>
                          <span>00</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Status</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                         <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">Order</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">OrderID</span>
                          <span className="punctuation">{">"}</span>
                          <span>1718</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">OrderID</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">SessionID</span>
                          <span className="punctuation">{">"}</span>
                          <span>alaoznssnmkg</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">SessionID</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">            </span>
                          <span className="punctuation">{"<"}</span>
                          <span className="property ">URL</span>
                          <span className="punctuation">{">"}</span>
                          <span>https://libertypaytxtest.lb.ge/twpga</span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">URL</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">        </span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Order</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain">    </span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">Response</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                        <span className="token-line">
                          <span className="token plain"></span>
                          <span className="punctuation">{"</"}</span>
                          <span className="property ">TKKPG</span>
                          <span className="punctuation">{">"}</span>
                          <span className="token plain"></span>
                          <br />
                        </span>
                      </code> 
                    </pre>
                  </div>
                </div>
                <div className="where-operation">
                  <h3>Where:</h3>
                  <div className="operation-text">
                    <p>
                      <span className="tag">Operation</span>
                      <span>- Operation Type.</span>
                    </p>
                    <p>
                      <span className="tag">Status</span>
                      <span>- Order status. 00 means no errors.</span>
                    </p>
                    <p>
                      <span className="tag">OrderID</span>
                      <span>– Order Id</span>
                    </p>
                    <p>
                      <span className="tag">SessionID</span>
                      <span>– Session Id or password.</span>
                    </p>
                    <p>
                      <span className="tag">URL</span>
                      <span>
                        - payment page url if not provided use one written
                        below.
                      </span>
                    </p>
                  </div>
                </div>

                <div className="other-hint">
                  <p className="pb-16">
                    After that merchant redirects client to the following URL
                    where client enters payment data and completes payment
                    process.
                  </p>
                  <a
                    href="https://libertypaytxtest.lb.ge/twpga?id=1718&password= alaoznssnmkg"
                    target="_blank"
                    className="link"
                  >
                    https://libertypaytxtest.lb.ge/twpga?id=1718&password=
                    alaoznssnmkg
                  </a>
                </div>
              </>
            )}{" "}
          </div>
        </div>
      </div>
    </>
  );
}
